import axios from "axios";

const useAxios = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/v1/nfc`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default useAxios;
